
<div
  v-if="isCurrentApp"
  class="webtool"
  @mouseleave="onMouseLeave"
  @mouseenter="onMouseEnter"
>
  <div class="webtool-icon-container">
    <img class="webtool-icon" :src="iconSrc" alt="" />
  </div>
  <div class="webtool-text-container">
    <div>
      <p class="app-name">{{ appData.title }}</p>
      <p class="app-subtitle">{{ appData.subtitle }}</p>
    </div>
  </div>
  <div class="nav-selection-underline-static"></div>
  <!-- Info Icon + Progress Circle -->
  <info-progress-circle
    v-if="appData.showInfoIcon"
    :progressOffset="progressOffset"
    :background-color="headerBackgroundColor"
  />
  <!-- Use the appropriate InfoCard component based on the app type -->
  <app-info-card :visible="appData.popupVisible" :app-data="appData" />
</div>
<div
  v-else
  :class="[
    'webtool notcurrentapp',
    { userdoesnthaveaccess: !appData.userAccess }
  ]"
  @click="clickedTool"
  @mouseenter="onMouseEnter"
  @mouseleave="onMouseLeave"
>
  <div
    class="webtool-icon-container"
    :style="{ opacity: appData.userAccess ? 1 : 0.4 }"
  >
    <img class="webtool-icon" :src="iconSrc" alt="" />
  </div>
  <div
    class="webtool-text-container"
    :style="{ opacity: appData.userAccess ? 1 : 0.4 }"
  >
    <div>
      <p class="app-name">{{ appData.title }}</p>
      <p class="app-subtitle">{{ appData.subtitle }}</p>
    </div>
  </div>
  <div class="nav-selection-underline"></div>

  <!-- Info Icon + Progress Circle -->
  <info-progress-circle
    v-if="appData.showInfoIcon"
    :progressOffset="progressOffset"
    :background-color="headerBackgroundColor"
  />

  <app-info-card :visible="appData.popupVisible" :app-data="appData" />
</div>
